export const textEn = {
  navbar: {
    brand: "OTM Trading",
    features: "Features",
    pricing: "Pricing",
    support: "Support",
    resources: "Resources",
    getStarted: "Get Started"
  },
  hero: {
    title: "Unlock Your Trading Potential with OTM Trading",
    subtitle: "Elevate your trading strategy with our advanced indicators for NinjaTrader. Gain a competitive edge with real-time insights and precision signals.",
    cta: "Get Started"
  },
  whyChoose: {
    title: "Why Choose OTM Trading?"
  },
  value: {
    title: "Empowering Traders with Cutting-Edge Technology",
    paragraph: "OTM Trading offers a suite of powerful indicators designed to enhance your trading experience on NinjaTrader. Our tools provide real-time data, advanced analytics, and reliable signals, giving you the edge you need to succeed in today's markets.",
    cards: [
      {
        title: "Advanced Indicators",
        desc: "Our indicators provide deep market analysis and actionable insights, helping you make informed trading decisions."
      },
      {
        title: "Real-Time Data",
        desc: "Access up-to-the-minute market data and signals, ensuring you never miss a trading opportunity."
      },
      {
        title: "Secure & Reliable",
        desc: "Trust in our robust and secure platform, designed to protect your data and provide consistent performance."
      }
    ]
  },
  pricing: {
    title: "Product Packages & Pricing",
    plans: [
      {
        name: "Basic",
        price: "$99/month",
        features: ["Core indicators", "Basic Support"]
      },
      {
        name: "Pro",
        price: "$199/month",
        features: ["All Basic Features", "Advanced Indicators", "Priority Support"],
        bestValue: true
      },
      {
        name: "Premium",
        price: "$299/month",
        features: ["All Pro Features", "Exclusive Indicators", "VIP Support"]
      }
    ]
  },
  testimonials: {
    title: "What Our Users Say",
    list: [
      {
        name: "Ethan Carter",
        date: "2023-08-15",
        text: "OTM Trading has transformed my trading. The indicators are incredibly accurate, and the support team is always ready to help."
      },
      {
        name: "Olivia Bennett",
        date: "2023-09-22",
        text: "I’ve seen a significant improvement in my trading results since using OTM. The real-time data is invaluable."
      },
      {
        name: "Noah Thompson",
        date: "2023-10-10",
        text: "The Premium package is worth every penny. The exclusive indicators give me a unique advantage in the market."
      }
    ]
  },
  education: {
    title: "Learn and Grow with OTM Trading",
    paragraph: "Access a wealth of educational resources designed to help you master our indicators and enhance your trading skills. From beginner guides to advanced strategies, we have everything you need to succeed.",
    cards: [
      {
        title: "Trading Guides",
        desc: "Comprehensive guides to help you understand our indicators and improve your trading strategies."
      },
      {
        title: "Video Tutorials",
        desc: "Step-by-step video tutorials to get you up and running with OTM Trading."
      },
      {
        title: "FAQ",
        desc: "Answers to frequently asked questions about our products and services."
      }
    ]
  },
  faq: {
    title: "Frequently Asked Questions",
    questions: [
      {
        q: "What is OTM Trading?",
        a: "OTM Trading provides advanced trading indicators for NinjaTrader, designed to give traders a competitive edge with real-time data and precision signals."
      },
      {
        q: "How do I get started?",
        a: "Click on 'Get Started' and follow the instructions to begin your journey with OTM Trading."
      },
      {
        q: "What support options are available?",
        a: "We offer basic, priority, and VIP support depending on your plan."
      }
    ]
  },
  ctaFinal: {
    text: "Ready to Take Your Trading to the Next Level?",
    subtext: "Join thousands of traders who trust OTM Trading for their success.",
    cta: "Get Started"
  },
  footer: {
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    contact: "Contact Us",
    copyright: "© 2023 OTM Trading. All rights reserved."
  }
};

export const textEs = {
  navbar: {
    brand: "OTM Trading",
    features: "Características",
    pricing: "Precios",
    support: "Soporte",
    resources: "Recursos",
    getStarted: "Empieza Ahora"
  },
  hero: {
    title: "Desbloquea tu Potencial de Trading con OTM Trading",
    subtitle: "Eleva tu estrategia de trading con nuestros indicadores avanzados para NinjaTrader. Obtén una ventaja competitiva con información en tiempo real y señales precisas.",
    cta: "Empieza Ahora"
  },
  whyChoose: {
    title: "¿Por qué elegir OTM Trading?"
  },
  value: {
    title: "Potenciando Traders con Tecnología de Punta",
    paragraph: "OTM Trading ofrece un conjunto de potentes indicadores diseñados para mejorar tu experiencia de trading en NinjaTrader. Nuestras herramientas proporcionan datos en tiempo real, análisis avanzados y señales confiables, dándote la ventaja que necesitas para tener éxito en los mercados actuales.",
    cards: [
      {
        title: "Indicadores Avanzados",
        desc: "Nuestros indicadores brindan un análisis profundo del mercado y conocimientos accionables, ayudándote a tomar decisiones informadas de trading."
      },
      {
        title: "Datos en Tiempo Real",
        desc: "Accede a datos y señales de mercado al minuto, asegurando que nunca pierdas una oportunidad de trading."
      },
      {
        title: "Seguro y Confiable",
        desc: "Confía en nuestra plataforma robusta y segura, diseñada para proteger tus datos y ofrecer un rendimiento consistente."
      }
    ]
  },
  pricing: {
    title: "Paquetes de Productos y Precios",
    plans: [
      {
        name: "Básico",
        price: "$99/mes",
        features: ["Indicadores principales", "Soporte básico"]
      },
      {
        name: "Pro",
        price: "$199/mes",
        features: ["Todas las funciones básicas", "Indicadores avanzados", "Soporte prioritario"],
        bestValue: true
      },
      {
        name: "Premium",
        price: "$299/mes",
        features: ["Todas las funciones Pro", "Indicadores exclusivos", "Soporte VIP"]
      }
    ]
  },
  testimonials: {
    title: "Lo que Dicen Nuestros Usuarios",
    list: [
      {
        name: "Ethan Carter",
        date: "2023-08-15",
        text: "OTM Trading ha transformado mi trading. Los indicadores son increíblemente precisos y el equipo de soporte siempre está listo para ayudar."
      },
      {
        name: "Olivia Bennett",
        date: "2023-09-22",
        text: "He visto una mejora significativa en mis resultados de trading desde que uso OTM. Los datos en tiempo real son invaluables."
      },
      {
        name: "Noah Thompson",
        date: "2023-10-10",
        text: "El paquete Premium vale cada centavo. Los indicadores exclusivos me dan una ventaja única en el mercado."
      }
    ]
  },
  education: {
    title: "Aprende y Crece con OTM Trading",
    paragraph: "Accede a una gran cantidad de recursos educativos diseñados para ayudarte a dominar nuestros indicadores y mejorar tus habilidades de trading. Desde guías para principiantes hasta estrategias avanzadas, tenemos todo lo que necesitas para tener éxito.",
    cards: [
      {
        title: "Guías de Trading",
        desc: "Guías completas para ayudarte a entender nuestros indicadores y mejorar tus estrategias de trading."
      },
      {
        title: "Video Tutoriales",
        desc: "Tutoriales en video paso a paso para que empieces a usar OTM Trading rápidamente."
      },
      {
        title: "Preguntas Frecuentes",
        desc: "Respuestas a las preguntas más frecuentes sobre nuestros productos y servicios."
      }
    ]
  },
  faq: {
    title: "Preguntas Frecuentes",
    questions: [
      {
        q: "¿Qué es OTM Trading?",
        a: "OTM Trading proporciona indicadores de trading avanzados para NinjaTrader, diseñados para dar a los traders una ventaja competitiva con datos en tiempo real y señales precisas."
      },
      {
        q: "¿Cómo empiezo?",
        a: "Haz clic en 'Empieza Ahora' y sigue las instrucciones para comenzar tu experiencia con OTM Trading."
      },
      {
        q: "¿Qué opciones de soporte están disponibles?",
        a: "Ofrecemos soporte básico, prioritario y VIP según tu plan."
      }
    ]
  },
  ctaFinal: {
    text: "¿Listo para llevar tu trading al siguiente nivel?",
    subtext: "Únete a miles de traders que confían en OTM Trading para su éxito.",
    cta: "Empieza Ahora"
  },
  footer: {
    terms: "Términos de Servicio",
    privacy: "Política de Privacidad",
    contact: "Contáctanos",
    copyright: "© 2023 OTM Trading. Todos los derechos reservados."
  }
}; 